import { render } from "./ActivityManagement.vue?vue&type=template&id=1619ed77"
import script from "./ActivityManagement.vue?vue&type=script&lang=js"
export * from "./ActivityManagement.vue?vue&type=script&lang=js"

import "./ActivityManagement.vue?vue&type=style&index=0&id=1619ed77&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__